import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    textAlign: "left",
    fontFamily: "Sora",
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "2rem",
    color: "#191C1A",
  },

  descriptionBox: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "1rem",
  },

  description: {
    textAlign: "left",
    fontFamily: "Nunito",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#191C1A",
  },

  textfieldContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    paddingBotom: "1rem",
  },

  textfield: {
    height: "40px !important",
  },

  buttonContainer: {
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    gap: "0.5rem",
    paddingTop: "1.5rem",
  },

  buttonRemoval: {
    height: "38px !important",
    backgroundColor: "#BA1A1A !important",

    "&:disabled": {
      height: "38px !important",
      fontWeight: 600,
    },
  },
}));

export { useStyles };
